import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
    selector: 'help-placeholder',
    template: require('./help.placeholder.component.html'),
    styles: [require('../personal.account.shared.css'), require('./help.placeholder.component.css')]
})
export class HelpPlaceholderComponent implements OnInit, OnDestroy {
    title = '';

    constructor(private readonly route: ActivatedRoute) { }

    ngOnInit() {
        document.body.classList.add('personal-account-fit');
        this.title = (this.route.snapshot.data && this.route.snapshot.data.title) || 'Help';
    }

    ngOnDestroy() {
        document.body.classList.remove('personal-account-fit');
    }
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./Client/app/views/account.management/help/help.placeholder.component.ts